import { createApi } from "../axiosInstance";

const api = createApi("myBusiness");

// Fresh implementation, NOT the shared shareCapitalApiFactory — mybusiness's ShareCapital is
// fully local (own table `mybusiness_share_capital`, own ShareCapitalController), not proxied to
// fpo, unlike every other shared domain. Path prefix is /company/{companyId}/... (not
// /fpo/{fpoId}/...). The payload shape itself is identical to fpo's own ShareCapitalCreatePayload
// (both use `shareCertificateNumber`, `paymentDate`, etc.) — the shared ShareCapitalForm.jsx
// already emits the correct field names, confirmed against both backends' payload classes.
export const getShareCapital = (companyId, memberId) =>
  api.get(`/company/${companyId}/member/${memberId}/shares`);

// Every member's share capital record in one call (used for the Share Transfer folio dropdown).
export const getAllMembersShareCapital = (companyId) =>
  api.get(`/company/${companyId}/members/shares`);

export const createShareCapital = (companyId, memberId, data) =>
  api.post(`/company/${companyId}/member/${memberId}/shares`, data);

export const updateShareCapital = (companyId, memberId, id, data) =>
  api.patch(`/company/${companyId}/member/${memberId}/shares/${id}`, data);

export const getShareCapitalById = (companyId, memberId, id) =>
  api.get(`/company/${companyId}/member/${memberId}/shares/${id}`);

export const deleteShareCapitalById = (companyId, memberId, id) =>
  api.delete(`/company/${companyId}/member/${memberId}/shares/${id}`);

export const downloadShareCapital = (companyId, params) =>
  api.get(`/company/${companyId}/shares/download`, { params, responseType: "blob" });
